export default __webpack_public_path__ + "cfde501d7c25a082e39fb9df172e1713.webp";